import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation, useNavigate, useMatch } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }) => {
    const { isLoggedIn, defaultRole, user } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!isLoggedIn) {
            navigate('/login', { replace: true });
        }
    }, [isLoggedIn, navigate]);

    useEffect(() => {
        if (user?.isEmailVerfied === false) {
            navigate('/verifyemail', { replace: true });
        }
        //  else if (user.isEmailVerfied) {
        //     navigate('/', { replace: true });
        // }
    }, [user?.isEmailVerfied]);

    return children;
};

AuthGuard.propTypes = {
    children: PropTypes.node
};

export default AuthGuard;
